import { type ComponentType, lazy } from 'react';

import { reloadOnError } from '../../utils/reload_on_error';

/**
 * React.lazy with the app's chunk-failure handling: reloadOnError reloads the
 * page once (throttled via sessionStorage) when a lazy chunk fails to load
 * after a deploy.
 */
export function lazyComponent<TProps, TExport extends string>(
  load: () => Promise<Record<TExport, ComponentType<TProps>>>,
  exportName: TExport,
) {
  return lazy(() =>
    reloadOnError(load()).then((module) => {
      if (module) {
        return { default: module[exportName] };
      }
      // reloadOnError has started a page reload. Hold the suspense fallback
      // until it lands rather than rendering from an empty module.
      return new Promise<{ default: ComponentType<TProps> }>(() => {});
    }),
  );
}
